import { render, staticRenderFns } from "./releases.row.vue?vue&type=template&id=533e4aea&"
import script from "./releases.row.vue?vue&type=script&lang=js&"
export * from "./releases.row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports